import { createContext } from "react";

export const ContextObject = createContext();
